/**
 * MTM Before / After Audio Player
 * Vanilla JS — no jQuery dependency.
 * Supports multiple independent players on the same page.
 */

(function () {
  'use strict';

  const RING_C = 119.38; // 2π × r(19)

  function formatTime(sec) {
    if (!isFinite(sec)) return '0:00';
    const m = Math.floor(sec / 60);
    const s = Math.floor(sec % 60);
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  function initPlayer(el) {
    const audios      = el.querySelectorAll('.mtm-audio');
    const beforeAudio = el.querySelector('.mtm-audio[data-track="before"]');
    const afterAudio  = el.querySelector('.mtm-audio[data-track="after"]');
    const playBtn     = el.querySelector('.mtm-play-btn');
    const ringFill    = el.querySelector('.mtm-ring-fill');
    const progressTrack = el.querySelector('.mtm-progress-track');
    const progressFill  = el.querySelector('.mtm-progress-fill');
    const progressThumb = el.querySelector('.mtm-progress-thumb');
    const timeCurrent = el.querySelector('.mtm-time-current');
    const timeTotal   = el.querySelector('.mtm-time-total');
    const toggleBtns  = el.querySelectorAll('.mtm-toggle-btn');
    const toggleWrap  = el.querySelector('.mtm-toggle');

    // Inject per-player SVG gradient (IDs must be unique)
    const pid = el.id;
    const gradId = 'mtm-grad-' + pid;
    const svg = el.querySelector('.mtm-ring');
    if (svg && !svg.querySelector('defs')) {
      const defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
 defs.innerHTML = `
        <linearGradient id="${gradId}" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="#0072DC"/>
          <stop offset="100%" stop-color="#004FAE"/>
        </linearGradient>`;;
      svg.prepend(defs);
      if (ringFill) ringFill.setAttribute('stroke', `url(#${gradId})`);
    }

    let activeAudio  = beforeAudio;
    let inactiveAudio = afterAudio;
    let isPlaying    = false;
    let raf          = null;
    let scrubbing    = false;

    // Mute inactive track from the start
    beforeAudio.muted = false;
    afterAudio.muted  = true;

    /* ---- helpers ---- */
    function stopAll() {
      // Pause every player on the page that isn't this one
      document.querySelectorAll('.mtm-ab-player').forEach(function (other) {
        if (other === el) return;
        const otherBefore = other.querySelector('.mtm-audio[data-track="before"]');
        const otherAfter  = other.querySelector('.mtm-audio[data-track="after"]');
        if (otherBefore) otherBefore.pause();
        if (otherAfter)  otherAfter.pause();
        other.classList.remove('is-playing');
      });
    }

    function setProgress(pct) {
      const p = Math.max(0, Math.min(100, pct));
      if (progressFill)  progressFill.style.width = p + '%';
      if (progressThumb) progressThumb.style.left  = p + '%';
      if (ringFill) {
        const offset = RING_C - (p / 100) * RING_C;
        ringFill.style.strokeDashoffset = offset;
      }
    }

    function updateUI() {
      const dur = activeAudio.duration || 0;
      const cur = activeAudio.currentTime || 0;
      const pct = dur ? (cur / dur) * 100 : 0;

      if (!scrubbing) setProgress(pct);
      if (timeCurrent) timeCurrent.textContent = formatTime(cur);
      if (timeTotal)   timeTotal.textContent   = formatTime(dur);
    }

    function tick() {
      updateUI();
      if (isPlaying) raf = requestAnimationFrame(tick);
    }

    function play() {
      stopAll();
      isPlaying = true;
      el.classList.add('is-playing');
      activeAudio.muted   = false;
      inactiveAudio.muted = true;
      // Both loop so they stay in sync; only active one is audible
      activeAudio.play().catch(function () {});
      inactiveAudio.play().catch(function () {}); // keep synced silently
      raf = requestAnimationFrame(tick);
    }

    function pause() {
      isPlaying = false;
      el.classList.remove('is-playing');
      activeAudio.pause();
      inactiveAudio.pause();
      cancelAnimationFrame(raf);
      updateUI();
    }

    /* ---- Play / Pause ---- */
    playBtn.addEventListener('click', function () {
      if (isPlaying) {
        pause();
      } else {
        play();
      }
    });

    /* ---- Before / After toggle ---- */
    toggleBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const track = btn.dataset.track; // 'before' | 'after'
        if (
          (track === 'before' && activeAudio === beforeAudio) ||
          (track === 'after'  && activeAudio === afterAudio)
        ) return; // already active

        // Sync playback position
        const syncTime = activeAudio.currentTime;

        // Swap references
        if (track === 'after') {
          activeAudio   = afterAudio;
          inactiveAudio = beforeAudio;
          toggleWrap.classList.add('after-active');
        } else {
          activeAudio   = beforeAudio;
          inactiveAudio = afterAudio;
          toggleWrap.classList.remove('after-active');
        }

        // Apply sync time
        activeAudio.currentTime = syncTime;

        // Update toggle button states
        toggleBtns.forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });

        // If already playing, seamlessly switch audio
        if (isPlaying) {
          inactiveAudio.muted = true;
          activeAudio.muted   = false;
          activeAudio.play().catch(function () {});
        } else {
          // Not playing — just mute accordingly
          inactiveAudio.muted = true;
          activeAudio.muted   = false;
        }
      });
    });

    /* ---- Progress bar scrubbing ---- */
    function seek(e) {
      const rect = progressTrack.getBoundingClientRect();
      const pct  = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
      const dur  = activeAudio.duration || 0;
      if (!dur) return;
      activeAudio.currentTime   = pct * dur;
      inactiveAudio.currentTime = pct * dur;
      setProgress(pct * 100);
    }

    progressTrack.addEventListener('mousedown', function (e) {
      scrubbing = true;
      seek(e);
    });
    progressTrack.addEventListener('click', seek);
    document.addEventListener('mousemove', function (e) {
      if (scrubbing) seek(e);
    });
    document.addEventListener('mouseup', function () {
      scrubbing = false;
    });

    /* ---- Touch scrubbing ---- */
    progressTrack.addEventListener('touchstart', function (e) {
      scrubbing = true;
      seek(e.touches[0]);
    }, { passive: true });
    document.addEventListener('touchmove', function (e) {
      if (scrubbing) seek(e.touches[0]);
    }, { passive: true });
    document.addEventListener('touchend', function () {
      scrubbing = false;
    });

    /* ---- Duration ready ---- */
    function onMeta() { updateUI(); }
    beforeAudio.addEventListener('loadedmetadata', onMeta);
    afterAudio.addEventListener('loadedmetadata', onMeta);

    /* ---- FUSER speed (23 Oct 2026): tracks are preload="none" so they don't compete with the page while it loads.
       Once the page has fully loaded, fetch just the track lengths so the total time shows as before. Pressing
       play before then still works: play() loads the audio itself. ---- */
    function warmMeta() {
      if (isPlaying) return;
      [beforeAudio, afterAudio].forEach(function (a) {
        if (a && a.preload === 'none' && a.readyState === 0) {
          a.preload = 'metadata';
          a.load();
        }
      });
    }
    if (document.readyState === 'complete') {
      setTimeout(warmMeta, 1500);
    } else {
      window.addEventListener('load', function () { setTimeout(warmMeta, 1500); });
    }

    /* ---- Loop ended guard (shouldn't be needed with loop attr but just in case) ---- */
    activeAudio.addEventListener('ended', function () {
      if (isPlaying) {
        activeAudio.currentTime = 0;
        inactiveAudio.currentTime = 0;
        activeAudio.play().catch(function () {});
      }
    });
  }

  /* ---- Init all players on page ---- */
  function initAll() {
    document.querySelectorAll('.mtm-ab-player').forEach(function (el) {
      if (!el.dataset.mtmInit) {
        el.dataset.mtmInit = '1';
        initPlayer(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init on Shopify section re-render
  document.addEventListener('shopify:section:load', initAll);

})();